import {
	applySsidScheduleFilter,
	focusSsidSchedule,
	openSsidScheduleSection,
} from './adapter';
import {
	openSsidScheduleEditModal,
	openSsidScheduleCreateModal,
	openSsidScheduleDeleteModal,
} from './modal';
import {mapSsidSchedulePrefill} from './prefill';
import {resolveSsidSchedules} from './resolver';

/**
 * Open and optionally filter the Schedule inventory.
 * @param {object} command experience command
 * @return {Promise<void>} completion
 */
async function openInventory(command) {
	await openSsidScheduleSection();
	const query = command.params?.query;
	if (typeof query === 'string' && query.trim()) {
		await applySsidScheduleFilter(query);
	}
}

const ssidSchedulePlugin = {
	id: 'ssid_schedule',
	version: 1,
	commandVersion: 1,
	resource: 'ssid_schedule',
	operations: ['options', 'view', 'create', 'edit', 'delete'],
	dependencies: {
		plugins: ['canvas.navigation'],
		destinations: ['profile.dashboard'],
	},
	sections: {
		'profile.ssid_schedules': openSsidScheduleSection,
	},
	resolvers: {
		schedule: resolveSsidSchedules,
	},
	filters: {
		schedule: (command) => applySsidScheduleFilter(command.params?.query),
	},
	focusHandlers: {
		schedule: (command) => focusSsidSchedule(command.params?.entity_id),
	},
	modals: {
		'ssid_schedule.create': openSsidScheduleCreateModal,
		'ssid_schedule.edit': openSsidScheduleEditModal,
		'ssid_schedule.delete': openSsidScheduleDeleteModal,
	},
	prefillMappers: {
		'ssid_schedule.create': mapSsidSchedulePrefill,
		'ssid_schedule.edit': mapSsidSchedulePrefill,
	},
	experiences: {
		'ssid_schedule.inventory': openInventory,
	},
};

export default ssidSchedulePlugin;
